<div id="st_events_discovery_filter_drawer" class="filter_sidebar">
  <stupa-mobile-drawer [show_mobile_drawer]="visible()" (close_mobile_drawer)="closed.emit()"
    [drawerExtended]="true" panelStyleClass="event-filter-mobile-drawer-panel">
    <div id="st_events_discovery_filter_header" header
      class="sidebar-header event-discovery-filter-header d-flex align-items-center justify-content-between gap-2 w-100">
      <div id="st_events_discovery_filter_header_title" class="header-content d-flex align-items-center gap-2">
        <span class="header-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"
              d="M3 5h18l-7 8v6l-4 2v-8z" />
          </svg>
        </span>
        <h2 class="fs-16 fw-bold m-0">{{ 'filters' | translate }}</h2>
        @if (totalCount() > 0) {
        <span class="header-count-badge fs-10 fw-semibold">{{ totalCount() }}</span>
        }
      </div>
      <div class="event-filter-search-slot" [attr.aria-hidden]="showSearch() ? null : 'true'">
        @if (showSearch()) {
        <div class="event-filter-search">
          <svg class="event-filter-search-icon" width="14" height="14" viewBox="0 0 16 16" fill="none"
            aria-hidden="true">
            <path
              d="M14.91 15.86L9.15 10.1C8.7 10.48 8.17 10.78 7.57 10.99C6.98 11.21 6.36 11.31 5.72 11.31C4.16 11.31 2.83 10.77 1.75 9.69C0.66 8.6 0.12 7.28 0.12 5.71C0.12 4.14 0.66 2.82 1.75 1.73C2.83 0.65 4.16 0.1 5.72 0.1C7.29 0.1 8.62 0.65 9.7 1.73C10.79 2.82 11.33 4.14 11.33 5.71C11.33 6.36 11.22 6.99 11 7.58C10.78 8.18 10.49 8.7 10.12 9.14L15.88 14.9L14.91 15.86Z"
              fill="currentColor" />
          </svg>
          <input type="text" class="event-filter-search-input fs-13 fw-semibold"
            [attr.aria-label]="searchPlaceholderKey() | translate"
            [placeholder]="searchPlaceholderKey() | translate" [value]="query()" (input)="onQueryInput($event)" />
          @if (query().length > 0) {
          <button type="button" class="event-filter-search-clear" (click)="clearQuery()"
            [attr.aria-label]="'clear' | translate">
            <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
          }
        </div>
        }
      </div>
    </div>

    <div id="st_events_discovery_filter_body" content class="event-discovery-filter-body">
      <div class="sidebar-content">
        <nav id="st_events_discovery_filter_tabs" class="left-pane d-flex flex-column p-2 gap-1" role="tablist"
          aria-orientation="vertical" (keydown)="onTabKeydown($event)">
          @for (tab of tabs(); track tab.id) {
          <button type="button" role="tab" [id]="'st_events_discovery_filter_tab_' + tab.id"
            [attr.aria-controls]="'st_events_discovery_filter_panel_' + tab.id"
            [attr.aria-selected]="activeTab() === tab.id" [attr.tabindex]="activeTab() === tab.id ? 0 : -1"
            class="nav-item" [class.active]="activeTab() === tab.id" (click)="setTab(tab.id)">
            <span class="nav-label fs-12 fw-semibold">{{ tab.labelKey | translate }}</span>
            @if (tabCount(tab.id) > 0) {
            <span class="nav-badge fs-10 fw-semibold">{{ tabCount(tab.id) }}</span>
            }
          </button>
          }
        </nav>

        <div id="st_events_discovery_filter_panels" class="right-pane d-flex flex-column p-3 gap-2">
          @switch (activeTab()) {
          @case ('nearMe') {
          <div id="st_events_discovery_filter_panel_nearMe" role="tabpanel"
            aria-labelledby="st_events_discovery_filter_tab_nearMe">
            <div class="panel-header">
              <p class="panel-subtitle fs-11 fw-semibold m-0">{{ hintKey() | translate }}</p>
            </div>
            <div class="club-options d-flex flex-column gap-1">
              <label class="club-option fs-12 fw-semibold" [class.active]="nearMe()"
                for="st_events_discovery_filter_near_me">
                <input id="st_events_discovery_filter_near_me" type="checkbox" [checked]="nearMe()"
                  (change)="onNearMeChange($event)" />
                <span class="option-label">{{ 'near_me' | translate }}</span>
              </label>
            </div>
          </div>
          }
          @case ('status') {
          <div id="st_events_discovery_filter_panel_status" role="tabpanel"
            aria-labelledby="st_events_discovery_filter_tab_status">
            <div class="panel-header">
              <p class="panel-subtitle fs-11 fw-semibold m-0">{{ hintKey() | translate }}</p>
            </div>
            @if (filteredStatuses().length > 0) {
            <div class="club-options d-flex flex-column gap-1">
              @for (status of filteredStatuses(); track statusValue(status)) {
              <label class="club-option fs-12 fw-semibold" [class.active]="isStatusSelected(status)"
                [attr.for]="'st_events_discovery_filter_status_' + statusValue(status)">
                <input type="checkbox" [id]="'st_events_discovery_filter_status_' + statusValue(status)"
                  [checked]="isStatusSelected(status)" (change)="statusToggle.emit(statusValue(status))" />
                <span class="option-label">{{ status.status_description | translate | uppercase }}</span>
              </label>
              }
            </div>
            } @else {
            <div class="filter-empty-state h-100">
              <stupa-empty-state [purpose]="emptyPurpose()" />
            </div>
            }
          </div>
          }
          @case ('season') {
          <div id="st_events_discovery_filter_panel_season" role="tabpanel"
            aria-labelledby="st_events_discovery_filter_tab_season">
            <div class="panel-header">
              <p class="panel-subtitle fs-11 fw-semibold m-0">{{ hintKey() | translate }}</p>
            </div>
            @if (filteredSeasons().length > 0) {
            <div class="club-options d-flex flex-column gap-1">
              @for (season of filteredSeasons(); track seasonValue(season)) {
              <label class="club-option fs-12 fw-semibold" [class.active]="isSeasonSelected(season)"
                [attr.for]="'st_events_discovery_filter_season_' + seasonValue(season)">
                <input type="checkbox" [id]="'st_events_discovery_filter_season_' + seasonValue(season)"
                  [checked]="isSeasonSelected(season)" (change)="seasonToggle.emit(seasonValue(season))" />
                <span class="option-label">{{ season.season_name }}</span>
              </label>
              }
            </div>
            } @else {
            <div class="filter-empty-state h-100">
              <stupa-empty-state [purpose]="emptyPurpose()" />
            </div>
            }
          </div>
          }
          @case ('level') {
          <div id="st_events_discovery_filter_panel_level" role="tabpanel"
            aria-labelledby="st_events_discovery_filter_tab_level">
            <div class="panel-header">
              <p class="panel-subtitle fs-11 fw-semibold m-0">{{ hintKey() | translate }}</p>
            </div>
            @if (filteredLevels().length > 0) {
            <div class="club-options d-flex flex-column gap-1">
              @for (level of filteredLevels(); track level.label) {
              <label class="club-option fs-12 fw-semibold" [class.active]="isLevelSelected(level)"
                [attr.for]="'st_events_discovery_filter_level_' + levelDomId(level)">
                <input type="checkbox" [id]="'st_events_discovery_filter_level_' + levelDomId(level)"
                  [checked]="isLevelSelected(level)" (change)="levelToggle.emit(level.label)" />
                <span class="option-label">{{ level.label }}</span>
              </label>
              }
            </div>
            } @else {
            <div class="filter-empty-state h-100">
              <stupa-empty-state [purpose]="emptyPurpose()" />
            </div>
            }
          </div>
          }
          @case ('date') {
          <div id="st_events_discovery_filter_panel_date" class="discovery-date-panel" role="tabpanel"
            aria-labelledby="st_events_discovery_filter_tab_date">
            <div class="panel-header">
              <p class="panel-subtitle fs-11 fw-semibold m-0">{{ hintKey() | translate }}</p>
            </div>
            <ng-content select="[date-panel]" />
          </div>
          }
          }
        </div>
      </div>
    </div>

    <div id="st_events_discovery_filter_footer" footer
      class="sidebar-footer event-discovery-filter-footer d-flex align-items-center justify-content-end gap-2 w-100">
      <button type="button" class="clear-btn fs-12 fw-semibold" (click)="clearFilters()">
        {{ 'clear_filters' | translate }}
        @if (totalCount() > 0) {
        <span class="footer-count-badge fs-10 fw-semibold">{{ totalCount() }}</span>
        }
      </button>
      <button type="button" class="apply-btn fs-13 fw-semibold" (click)="applied.emit()">
        {{ 'apply' | translate }}
      </button>
    </div>
  </stupa-mobile-drawer>
</div>
